function findMembersOnlyMarker(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_COMMENT);

    while (walker.nextNode()) {
        if (walker.currentNode.nodeValue.trim() === 'members-only') {
            return walker.currentNode;
        }
    }

    return null;
}

function removeContentAfterMarker(markerNode) {
    let currentNode = markerNode.nextSibling;

    while (currentNode) {
        const nextNode = currentNode.nextSibling;
        currentNode.remove();
        currentNode = nextNode;
    }

    markerNode.remove();
}

function createPaywallCta() {
    const cta = document.createElement('div');
    cta.className = 'gh-post-upgrade-cta';
    cta.innerHTML = `
        <h3>Այս հատվածը միայն բաժանորդների համար է</h3>
        <p>Մուտք գործեք ամբողջական նյութը կարդալու համար։</p>
        <div class="gh-post-upgrade-cta-actions">
            <a class="gh-button" href="/signin/">Մուտք</a>
        </div>
    `;

    return cta;
}

export default function paywallAccess() {
    if (document.body.dataset.member === 'true') {
        return;
    }

    const postContent = document.querySelector('.post-template .rb-card-section');
    if (!postContent) {
        return;
    }

    const markerNode = findMembersOnlyMarker(postContent);
    if (!markerNode) {
        return;
    }

    removeContentAfterMarker(markerNode);
    postContent.appendChild(createPaywallCta());
}
